
import { getGeocoderAPI } from '@/api';
import axios from 'axios';
import { mapBoxProxyToken } from '@/constants';

export function getMapBoxObjectFromForm(placeName, street, city, state, zip) {
  return {
    address: placeName,
    street,
    city,
    state,
    zip,
    neighborhood: null
  };
}

export function getMapBoxSelections(item) {
  item = typeof item === 'string' ? JSON.parse(item) : item
  if (!item || typeof item.place_type === 'undefined') return undefined;
  let contextValues = {};

  item.context.forEach(element => {
    contextValues[element.id.split('.')[0]] = element.text
  });

  const parsedCity = contextValues.place ?? item.text ?? item.place_name.split(', ')[0];

  let retVal = {
    address: item.place_name,
    county: contextValues.district,
    latitude: item.geometry.coordinates[1],
    longitude: item.geometry.coordinates[0],
    street: item?.address ? `${item.address} ${item.text}` : `${item.text}`, // todo: move to seller only for refactor
    city: parsedCity,
    state: contextValues.region,
    zip: contextValues.postcode,
    neighborhood: contextValues.neighborhood
  }

  return retVal
}

export async function getLocationResults(searchInputText, searchType) {
  const url = getGeocoderAPI(searchInputText, searchType);
  const results = await axios.get(url,
    {
      headers: { 'x-api-key': mapBoxProxyToken }
    });
  return results?.data?.features ?? [];
}

export async function getMapBoxMatch (address, lat, lng, type) {
  const topResults = await getLocationResults(address, type);
  let bestMatch = {}
  topResults.forEach(x => {
    if (x?.geometry?.coordinates[1] == lat && x?.geometry?.coordinates[0] == lng) {
      bestMatch = x
    }
  });
  return bestMatch;
}

export function isValidLatLngFromUrlObject (urlAddress) {
  const regexLat = /^(-?[1-8]?\d(?:\.\d{1,18})?|90(?:\.0{1,18})?)$/;
  const regexLon = /^(-?(?:1[0-7]|[1-9])?\d(?:\.\d{1,18})?|180(?:\.0{1,18})?)$/;
  let validLat = regexLat.test(urlAddress?.latitude);
  let validLon = regexLon.test(urlAddress?.longitude);
  return validLat && validLon;  
}

export function isValidFromUrlObject (urlAddress, requiresParams) {
  return requiresParams?.every((x) => urlAddress[x]);
}
